var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"restaurants"}},[_c('div',{staticClass:"adaptive-column-content"},[(!_vm.isSmartphone)?_c('h2',[_vm._v("Наши рестораны")]):_vm._e(),_vm._v(" "),(_vm.restaurants.length === 0)?_c('content-loader',{attrs:{"title":"Пожалуйста, подождите, мы загружаем рестораны"}}):_vm._l((_vm.restaurants),function(restaurant){return _c('restaurant',{key:restaurant.id,attrs:{"restaurant":restaurant}})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/index/Restaurants.vue?vue&type=template&id=5c8b8d53&
// module id = 744
// module chunks = 2